module.exports = __webpack_public_path__ + "d7980fc4cd8b2e8c948de201d30fd46d.jpg";